import styled from 'styled-components';

export const SingleNewHireException = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const ChangeFlagRadio = styled.input`
  border-radius: 10px;
`;
